import { render, staticRenderFns } from "./repMat.pug?vue&type=template&id=a8b73178&lang=pug&"
import script from "./repMat.js?vue&type=script&lang=js&"
export * from "./repMat.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8b73178')) {
      api.createRecord('a8b73178', component.options)
    } else {
      api.reload('a8b73178', component.options)
    }
    module.hot.accept("./repMat.pug?vue&type=template&id=a8b73178&lang=pug&", function () {
      api.rerender('a8b73178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminGAGLayout/views/repMat/index.vue"
export default component.exports